import { CONST } from "../../../CONST";
import Distraction, { DistractionConfig, DistractionState} from "../Distraction";

const CONFIG = {
    animation: {
        movement: {
            duration: 750,
            ease: {in: "Quad.easeOut", out: "Quad.easeIn"},
            from: {x: -225, y: 30},
        },

        images: [
            {key: CONST.DISTRACTION.BALL_1, offset: {x: 20, y: 0}},
            {key: CONST.DISTRACTION.BALL_2, offset: {x: 0, y: 0}},
            {key: CONST.DISTRACTION.BALL_3, offset: {x: 0, y: 1}},
            {key: CONST.DISTRACTION.BALL_4, offset: {x: 0, y: -5}},
            {key: CONST.DISTRACTION.BALL_5, offset: {x: 0, y: 2}},
            {key: CONST.DISTRACTION.BALL_6, offset: {x: 0, y: 1}},
        ],

    }
}

export default class BallDistraction extends Distraction {

    private container : Phaser.GameObjects.Container;
    private ballImg : Phaser.GameObjects.Image;
    

    private imgTween !: Phaser.Tweens.Tween;
    private moveTween !: Phaser.Tweens.Tween;
    private activeTween !: Phaser.Tweens.Tween;

    constructor(scene: Phaser.Scene, config: DistractionConfig){
        super(scene, config);

        this.container = scene.add.container(config.x + CONFIG.animation.movement.from.x, config.y + CONFIG.animation.movement.from.y).setDepth(config.depth);

        this.ballImg = scene.add.image(0, 0, CONST.DISTRACTION.BALL_1);
        this.ballImg.setInteractive({useHandCursor: true, pixelPerfect: true, alphaTolerance: 1});
        this.ballImg.on("pointerup", () => {
            this.handleClick();
        });

        this.setBallImage(0);

        this.container.add([this.ballImg]);
        this.init();
    }

    animateMovement(rollingIn : boolean){
        if (this.moveTween){
            this.moveTween.stop();
        }

        this.container.setPosition(this.config.x + (rollingIn ? CONFIG.animation.movement.from.x : 0),
            this.config.y + (rollingIn ? CONFIG.animation.movement.from.y : 0));

        this.moveTween = this.scene.tweens.add({
            targets: this.container,
            x: this.config.x + (rollingIn ? 0 : CONFIG.animation.movement.from.x),
            y: this.config.y + (rollingIn ? 0 : CONFIG.animation.movement.from.y),
            ease: rollingIn ? CONFIG.animation.movement.ease.in : CONFIG.animation.movement.ease.out,
            duration: CONFIG.animation.movement.duration,
            repeat: 0,
        });
    }

    animateBallImages(rollingIn : boolean){
        if (this.imgTween){
            this.imgTween.stop();
        }
        this.setBallImage(rollingIn? 0 : CONFIG.animation.images.length - 1);

        this.imgTween = this.scene.tweens.addCounter({
            targets: this,
            from: rollingIn ? 0 : CONFIG.animation.images.length + 0.3,
            to: rollingIn ? CONFIG.animation.images.length+0.3: 0,
            ease: rollingIn ? CONFIG.animation.movement.ease.in : CONFIG.animation.movement.ease.out,
            repeat: 0,
            delay: rollingIn ? 0 : 0,
            duration: CONFIG.animation.movement.duration,//CONFIG.animation.images.length * CONFIG.animation.msPerImage,
            onUpdate: function(tween:Phaser.Tweens.Tween, key : any, targets : any){
                var value = Math.max(0, Math.floor(tween.getValue() - 1));
                this.setBallImage(value);
            },
            onUpdateScope: this,
        });
    }

    setBallImage(img: number){
        img = Math.round(img) % CONFIG.animation.images.length;
        let conf = CONFIG.animation.images[img];
        this.ballImg.setTexture(conf.key);
        this.ballImg.setPosition(conf.offset.x, conf.offset.y);
    }

    animateActive(isActive: boolean){
        if (isActive){
            this.activeTween = this.scene.tweens.add({
                targets: this.ballImg,
               scaleX: 1.1,
               scaleY: 1.1,
    
                ease: "Quad.easeOut",
                duration: 400,
                repeat: -1,
                yoyo: true,
                onStart: () => {
                    this.scene.sound.play(CONST.AUDIO.BOUNCE, {detune: this.scene.getDetune(), volume: 2});
                },
                onRepeat: () => {
                    this.scene.sound.play(CONST.AUDIO.BOUNCE, {detune: this.scene.getDetune(), volume: 2});
                },
            });
        } else {
            this.ballImg.setScale(1);
            if (this.activeTween){
                this.activeTween.stop();
            }
        }
        
    }

    private handleClick(){
        this.deactivate();
    }

    onDeactivated(): void {
        this.ballImg.clearTint();
    }

    onStarting(): void {
        this.animateBallImages(true);
        this.animateMovement(true);

        setTimeout(() => {
            this.changeState(DistractionState.Active);
        }, CONFIG.animation.movement.duration);

    }

    onActivated(): void {
        this.animateActive(true);
    }

    onEnding(): void {
        this.animateBallImages(false);
        this.animateMovement(false);

        this.animateActive(false);


        setTimeout(() => {
            this.changeState(DistractionState.Deactivated);
        }, CONFIG.animation.movement.duration);
    }

    onGameLost(): void {
        this.ballImg.disableInteractive();
    }
}